module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQElEQVR42mP8//8/AwZwc3NjYGDYtWsXphQTA4lgEGpgxOppqtrg6uqKzIcEJXKwQtiD2Q/YNbi5uaE5fVglDQD+mBSH/qCz6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/crosshair.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/crosshair.png
// module chunks = styles